import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  TabContent, TabPane, Nav, NavItem, NavLink
} from 'reactstrap';
import { connect } from 'react-redux';
import { ICommissionBlockReasonsModal, IAuthReduxProps, ITarget } from '../../types/interfaces';
import { getUsersByPrivilegePromise } from '../../flux/actions/userActions';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle, faExternalLinkAlt, faUser } from '@fortawesome/free-solid-svg-icons'
import { E_ERROR } from '../../types/errors';
import { useHistory } from 'react-router-dom';
import { useAlert } from "react-alert";
import Loading from '../Loading';
import TableContainer from '../tables_manager/TableContainer';
import EncaissementListTable from '../encaissement_list/EncaissementListTable';
import VenteListTable from '../vente_list/VenteListTable';

const CommissionBlockReasonsModal = ({
  modal,
  setModal,
  reasons,
  auth
 }: ICommissionBlockReasonsModal) => {
  const history = useHistory();
  const alert = useAlert();
  const BLOCK_REASON_ENC = "BLOCK_REASON_ENC"
  const BLOCK_REASON_VENTE = "BLOCK_REASON_VENTE"
  const [activeTab, setActiveTab] = useState(BLOCK_REASON_ENC);

  const handleToggle = () => setModal(!modal);

  return <Modal isOpen={modal} toggle={handleToggle} className="modal-dialog-extra-large">
    <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faExclamationTriangle} />&nbsp;&nbsp;Raisons blocage de la commission</ModalHeader>
    <ModalBody>
      {/* <Container className="linesConfirmationContainer"> */}
        {/* <Input placeholder="Recherche..." value={blockCommissionReasonsSearchText} onChange={e => setBlockCommissionReasonsSearchText(e.target.value)} style={{marginBottom: "10px"}} />
        {blockCommissionReasons.filter(e => e?.toLowerCase().includes(blockCommissionReasonsSearchText?.toLowerCase() || '')).map((e, key) => <Row key={key} className="CardInfo">
          <Col xs="12">{e}</Col>
        </Row>)} */}
        <Nav tabs>
          <NavItem>
            <NavLink
              className={`fullFlexCenter${activeTab === BLOCK_REASON_ENC ? " active" : ""}`}
              onClick={() => setActiveTab(BLOCK_REASON_ENC)} >
              Chèques Inactifs ({reasons?.inactifChequeData?.length || 0})
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={`fullFlexCenter${activeTab === BLOCK_REASON_VENTE ? " active" : ""}`}
              onClick={() => setActiveTab(BLOCK_REASON_VENTE)} >
              Ventes non Encaissés ({(reasons?.nonEncaisseVData?.length || 0) + (reasons?.nonEncaissePData?.length || 0)})
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={BLOCK_REASON_ENC}>
            <EncaissementListTable encaissementsData={(reasons?.inactifChequeData || []).map(e => ({...e.data, commissionBlockReason: e.text || ""}))} showProjectColumn showStatutColumn commissionBlockPopup />
          </TabPane>
          <TabPane tabId={BLOCK_REASON_VENTE}>
            <VenteListTable ventesData={[
              ...(reasons?.nonEncaisseVData || []).map(e => ({...e.data, commissionBlockReason: e.text || ""})),
              ...(reasons?.nonEncaissePData || []).map(e => ({...e.data, vente: e.data?.contrat, commissionBlockReason: e.text || "", isAssLine: true})),
            ]} showProjectColumn allAssociationsShown commissionBlockPopup />
          </TabPane>
        </TabContent>
      {/* </Container> */}
    </ModalBody>
  </Modal>
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error
});

export default connect(mapStateToProps, { })(CommissionBlockReasonsModal);
